import { useState, useMemo } from 'react';
import { videoArticles } from '@/mocks/videos';
import VideoCard from '@/components/base/VideoCard';
import { categories } from '@/mocks/categories';

export default function LatestVideos() {
  const [activeCategory, setActiveCategory] = useState('all');
  const [showAll, setShowAll] = useState(false);

  const filteredVideos = useMemo(() => {
    let videos = [...videoArticles].sort(
      (a, b) => new Date(b.date).getTime() - new Date(a.date).getTime()
    );
    if (activeCategory === 'hot') {
      videos = videos.filter((v) => v.hot);
    } else if (activeCategory !== 'all') {
      videos = videos.filter((v) => v.category === activeCategory);
    }
    return videos;
  }, [activeCategory]);

  const displayVideos = showAll ? filteredVideos : filteredVideos.slice(0, 8);

  const tabCategories = categories.filter((c) =>
    c.slug === 'all' || c.slug === 'hot' || c.slug === 'movie' || c.slug === 'variety' || c.slug === 'music'
  );

  return (
    <section className="py-12 md:py-16 bg-background-100">
      <div className="mx-auto max-w-[1280px] px-4 md:px-6">
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 mb-8 md:mb-10">
          <div>
            <h2 className="text-xl md:text-2xl font-bold text-foreground-950 font-heading mb-1">
              最新福利视频
            </h2>
            <p className="text-sm text-foreground-500">
              每日更新精选内容，不错过任何精彩
            </p>
          </div>
        </div>

        <div className="flex items-center gap-2 mb-8 overflow-x-auto pb-2 flex-wrap">
          {tabCategories.map((cat) => (
            <button
              key={cat.id}
              onClick={() => {
                setActiveCategory(cat.slug);
                setShowAll(false);
              }}
              className={`px-4 py-1.5 rounded-full text-sm font-medium whitespace-nowrap cursor-pointer transition-colors ${
                activeCategory === cat.slug
                  ? 'bg-primary-500 text-background-50'
                  : 'bg-background-50 text-foreground-600 hover:bg-background-200 border border-background-200/70'
              }`}
            >
              {cat.name}
            </button>
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {displayVideos.map((video) => (
            <VideoCard key={video.id} video={video} />
          ))}
        </div>

        {filteredVideos.length > 8 && (
          <div className="mt-8 text-center">
            <button
              onClick={() => setShowAll(!showAll)}
              className="px-6 py-2 bg-background-50 border border-background-200/70 text-foreground-700 rounded-full text-sm font-medium hover:border-primary-300 hover:text-primary-500 cursor-pointer transition-colors whitespace-nowrap"
            >
              {showAll ? '收起' : `查看更多（共 ${filteredVideos.length} 个）`}
              <i className={`${showAll ? 'ri-arrow-up-s-line' : 'ri-arrow-down-s-line'} ml-1`}></i>
            </button>
          </div>
        )}
      </div>
    </section>
  );
}